import angular from "angular";
import { TimeEntryDashboardModule } from "./dashboard/time-entry-dashboard.module";
import { TimeEntryEditModule } from "./edit/time-entry-edit-module";

import { ListTimeEntriesContainerComponent } from "./list-time-entries/list-time-entries-container.component";
import { ListTimeCardsContainerComponent } from "./list-time-cards/list-time-cards-container.component";
import { TimeGapDecorator } from './time-gap-decorator.service';
import { TimeEntryRoutingModule } from "./time-entry-routing.module";

export const TimeEntryModule = angular
    .module("apex.mainApp.timeEntry", [
        TimeEntryDashboardModule,
        TimeEntryEditModule,
        TimeEntryRoutingModule
    ])
    .component("apexListTimeEntriesContainer", ListTimeEntriesContainerComponent)
    .component("apexListTimeCardsContainer", ListTimeCardsContainerComponent)
    .service("timeGapDecorator", TimeGapDecorator)
    .name;
